export default __webpack_public_path__ + "static/media/tailwindcss.e7b4a92d.svg";